import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Asset } from 'app/classes/asset';
import { Building } from 'app/classes/building';
import { CollectionAsset } from 'app/classes/collection-for-assets';
import { Gateway } from 'app/classes/gateway';
import { Insight } from 'app/classes/insight';
import { Org } from 'app/classes/org';
import { APIService } from 'app/shared/api.service';
import { BuildingsService } from 'app/shared/buildings.service';
import { CombinedCollectionItem, SiteService } from 'app/shared/site.service';
import { sign } from 'crypto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-insights-airquality-config',
  templateUrl: './insights-airquality-config.component.html',
  styleUrls: ['./insights-airquality-config.component.css'],
  providers: [],
  standalone: false
})
export class InsightsAirqualityConfigComponent implements OnInit, OnDestroy {

  readonly LOCALSTORAGE = 'iaq:config';

  previousBuildings = signal<IBuildingQuickPick[]>(null);
  isGettingBuilding = signal<boolean>(false);
  buildings = signal<Building[]>(null);
  building = signal<Building>(null);
  dialogOpen = signal<'buildings'>(null);
  gatewaysNotAvailable = signal<Gateway[]>(null);
  collections = signal<CollectionAsset[]>(null)
  gateway = signal<Gateway>(null);
  combinedCollections = signal<CombinedCollectionItem[]>(null);

  buildingForReport = signal<Building>(null);
  gateways: Gateway[];
  gatewaysSelected: Gateway[];
  month = signal<Date>(null);
  subs: Subscription[] = [];
  runReport = signal<boolean>(false);
  reportWasGenerated: boolean;
  reportWasGeneratedAt: Date;
  // Re-run report with latest data if true
  clearCache: boolean;
  generateItems = [
    {
      label: 'Clear cache & run', icon: 'mdi mdi-refresh', command: () => {
        this.generate(true);
      }
    }];
  org: Org;
  today = new Date();
  useOrgLogo = signal<boolean>(false);

  constructor(private apiService: APIService, private buildingService: BuildingsService, public siteService: SiteService) {
    this.getLocalStorage();
  }

  ngOnInit(): void {
    const buildingSub = this.buildingService.buildingList.subscribe(list => {
      if (!list) {
        return;
      }
      this.buildings.set(list);
    });

    this.subs.push(buildingSub);
    this.org = this.apiService.getUserOrg();
  }

  clickCollection(collection: CollectionAsset) {
    console.log(collection);
  }

  useAssetsForGateway(gateway: Gateway, assets: Asset[]) {
    this.gateway.set(null);
    assets.forEach(asset => gateway.assets.add(asset));

    this.gateways = [gateway];
  }

  buildingChange(building: Building) {
    this.dialogOpen.set(null);

    if (!building) {
      return;
    }

    this.building.set(building);
    this.addToPreviousBuildings(building);
    this.runReport.set(false);
    this.reportWasGenerated = false;
    this.buildingForReport.set(null);

    this.getBuilding(this.building().id);
  }

  addToPreviousBuildings(building: Building) {
    this.previousBuildings.set([{ id: building.id, title: building.title }]);
    this.saveLocalStorage();
  }

  getLocalStorage() {
    try {
      const storageString = localStorage.getItem(this.LOCALSTORAGE);
      if (storageString) {
        const storageObject = JSON.parse(storageString);
        this.previousBuildings.set(storageObject.previous);
      }
    } catch (e) { }
  }

  saveLocalStorage() {
    const payload = JSON.stringify({ previous: this.previousBuildings() });
    localStorage.setItem(this.LOCALSTORAGE, payload);
  }

  getBuilding(id: number) {
    this.isGettingBuilding.set(true);
    this.buildingService.getOne(id)
      .then(building => {
        this.buildingForReport.set(building);

        this.siteService.getCollections(building.site.id).then(collections => this.combinedCollections.set(collections.filter(c => c.type.id === CombinedCollectionItem.TYPE_AQ)));

        this.buildingService.getAQGatewaysAndCollectionsWithAssets(building.id)
          .then(response => {

            const { gateways, collections } = response;

            this.collections.set(collections);
            this.isGettingBuilding.set(false);
            if (gateways.length) {

              this.gateways = gateways.map(g => {
                g.selected = true;
                return g;
              });

            } else {
              /*
              this.buildingService.getGateways(building.id)
                .then(gateways => {
                  this.gatewaysNotAvailable.set(gateways);
                  this.isGettingBuilding.set(false);
                });
                */
            }

          });
      });
  }

  clickGatewaysNotAvailable(gateway: Gateway) {
    this.gateway.set(gateway);
  }

  getGateways() {

  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  toolbarClick(event: any) {
    const building = this.buildingForReport();
    /** @todo
this.dialogRef = this.dialogService.open(DialogOpeningHoursComponent, {
  header: `Hours for ${building.title}`,
  data: { openingHours: building.openingHours }
});
this.dialogRef.onClose.subscribe((openingHours: OpeningHours) => {
  if (openingHours) {
    this.buildingForReport.openingHours = openingHours;
    this.buildingService.updateHours(this.buildingForReport).then(b => {
      this.apiService.toastSuccess('updated hours.');
      this.getBuilding(building.id);
    });
  }
});
*/
  }

  generate(reGenerateDate = false) {
    this.clearCache = reGenerateDate;
    this.gatewaysSelected = this.gateways?.filter(g => g.selected) || [];

    const collectionsSelected = this.collections().filter(c => c.selected);

    if (this.gatewaysSelected.length === 0 && collectionsSelected.length === 0) {
      this.apiService.toastSuccess('Please select one or more gateways.');

      return;
    }
    if (!this.month()) {
      this.apiService.toastSuccess('Please select a month.');

      return;
    }

    if (this.runReport() && !this.reportWasGenerated) {
      console.log('REPORT_GENERATING_PLEASE_WAIT');

      return;
    }

    if (this.runReport()) {
      this.runReport.set(false);
      setTimeout(() => {
        this.runReport.set(true);
        this.reportWasGenerated = false;
      }, 10);
    } else {
      this.reportWasGenerated = false;
      this.runReport.set(true);
    }
  }

  onReportWasGenerated(insight: Insight) {
    if (insight === null) {
      this.reportWasGenerated = false;
      this.runReport.set(false);
      this.reportWasGeneratedAt = null;
    } else {
      this.reportWasGenerated = true;
      this.reportWasGeneratedAt = insight.generatedAt;
    }
  }

  printPage() {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.print();
    }, 100);
  }
}

export interface IBuildingQuickPick {
  id: number;
  title: string;
}
